/**
 * Card Wrapper Click Handler
 * Makes entire card clickable by delegating clicks to the primary link inside
 */

export function initCardWrappers() {
  const cardWrappers = document.querySelectorAll('.card-wrapper');

  cardWrappers.forEach(card => {
    // Find the primary link (btn-link inside the card)
    const primaryLink = card.querySelector('.btn-link');

    if (!primaryLink) return;

    // Make card clickable
    card.style.cursor = 'pointer';

    // Click handler
    card.addEventListener('click', (e) => {
      // Don't trigger if user is clicking on a link directly
      // or selecting text (to allow copy/paste)
      if (
        e.target.closest('a') ||
        window.getSelection().toString().length > 0
      ) {
        return;
      }

      // Trigger click on primary link
      primaryLink.click();
    });

    // Add keyboard accessibility
    card.setAttribute('tabindex', '0');
    card.setAttribute('role', 'article');

    card.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        primaryLink.click();
      }
    });
  });
}
